import React from "react";

export const CellTwoLines = ( {text, subtext} ) => (
  <>
  {text} <br/>
    <span className="gray small">{subtext}</span>
  </>
)